import { H6, TableCell, TableRow } from '@dhl-ui/components'

type Props = {
  title: string
}
export const DataHeading = ({ title }: Props) => (
  <TableRow>
    <TableCell colSpan={2}>
      <H6>{title}</H6>
    </TableCell>
  </TableRow>
)
